// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Nx-z","tooltipWrapper":"Ox-z","icon":"Px-z","tooltip":"Qx-z","content":"Rx-z"};